function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentNonrefundFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.312 3.254l1.418 1.411L4.688 28.746l-1.417-1.41L27.31 3.253z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.366 6.621c.57-.486 1.488-1.13 2.94-1.867l.035-.017.035-.015a12.137 12.137 0 017.785-.51A12.11 12.11 0 0127.756 19.1c-1.758 6.492-8.449 10.356-14.95 8.631A12.11 12.11 0 014.21 12.845l1.93.523a10.111 10.111 0 007.177 12.43c5.438 1.442 11.037-1.79 12.507-7.22a10.111 10.111 0 00-7.177-12.431 10.138 10.138 0 00-6.471.41c-1.317.67-2.088 1.224-2.514 1.588a3.851 3.851 0 00-.408.392 1.11 1.11 0 00-.055.068c-.003.003-.002.003 0-.001l.007-.01.004-.007.003-.004.001-.002.001-.002-.854-.52c-.854-.52-.853-.521-.853-.521v-.001l.002-.003.003-.005.007-.011a1.495 1.495 0 01.067-.096c.038-.053.09-.12.158-.197.135-.156.334-.36.62-.603z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.027 9.996l5.235.003-5.23-5.231-.005 5.228z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.423 18.523c0-.356-.13-.647-.39-.873-.26-.227-.704-.42-1.322-.615l-.996-.29c-.997-.292-1.723-.69-2.189-1.197-.465-.507-.704-1.153-.704-1.962 0-.678.174-1.282.51-1.8.335-.517.812-.915 1.418-1.206.607-.291 1.311-.442 2.102-.442.79 0 1.462.129 2.112.377.65.248 1.17.593 1.582 1.045l-.953 1.908c-.726-.83-1.636-1.25-2.73-1.25-.52 0-.932.107-1.224.312-.293.216-.444.496-.444.852 0 .312.119.582.368.786.25.205.64.4 1.18.55l.987.291c1.072.302 1.852.722 2.361 1.261.51.539.758 1.24.758 2.09 0 .701-.173 1.316-.509 1.844a3.314 3.314 0 01-1.419 1.207c-.607.28-1.343.42-2.21.42-.866 0-1.69-.15-2.437-.463-.748-.313-1.354-.744-1.82-1.293l.932-1.919c.877 1.078 1.96 1.617 3.25 1.617.573 0 1.018-.108 1.321-.324.303-.215.455-.517.455-.916l.01-.01z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.918 10.526V8.295h1.849v2.23h-1.848zM14.918 23.706v-2.22h1.849v2.22h-1.848z",
    fill: props.color
  }));
}

export default SvgIconPaymentNonrefundFilled;